import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/templateCenter/expectation.png")